import {
  DASH,
  DREAD_DARK,
  DREAD_LIGHT,
  GREEN_DARK,
  GREEN_LIGHT,
  SLATE_04,
} from "@/styles/colors";

export const SNACKBAR_TEXT_COLOR = {
  SUCCESS: GREEN_DARK,
  ERROR: DREAD_DARK,
  INFO: SLATE_04,
};

export const SNACKBAR_BG_COLOR = {
  SUCCESS: GREEN_LIGHT,
  ERROR: DREAD_LIGHT,
  INFO: DASH,
};
